import React from 'react'
import ThankContainer from '../../containers/Video/Calling/Thank'

const Thank: React.FC = () => {
  return <ThankContainer />
}

export const PATH = '/video/thank-you' as const
export default Thank
